module.exports = __webpack_public_path__ + "img/lg_ring_y_0_null_1@2x.1858600b.png";